<template>
  <div class="fs-4 ps-3 pb-2 text-center">
    {{ t("INCODE_COPY_LINK_HELP") }}
    <button
      class="btn btn-success mi-2"
      @click="copyIncodeUrl"
      data-test="copyIncodeUrlButton"
    >
      <i class="fa fa-link" aria-hidden="true"></i>{{ t("COPY_LINK") }}
    </button>
  </div>
</template>
<script setup>
import { useI18n } from "@/apps/merchant3/composables/useI18n";
const props = defineProps({
  incodeUrl: {
    type: String,
  },
});
const { t } = useI18n();

const copyIncodeUrl = async () => {
  await navigator.clipboard.writeText(props.incodeUrl);
};
</script>
